import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import AppWrapper from "./App";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import CookieSettingWrapper from "./CookieSettingWrapper"; // Import Wrapper

ReactDOM.render(
  
  <React.StrictMode>
    <AppWrapper />

    <CookieSettingWrapper /> {/* Use the wrapper */}

  </React.StrictMode>,
  document.getElementById("root")
);
